import { render, staticRenderFns } from "./AttrInfo.vue?vue&type=template&id=31b7c630&scoped=true"
import script from "./AttrInfo.vue?vue&type=script&lang=js"
export * from "./AttrInfo.vue?vue&type=script&lang=js"
import style0 from "./AttrInfo.vue?vue&type=style&index=0&id=31b7c630&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7c630",
  null
  
)

export default component.exports